import { useEffect } from "react";
import { useLang } from "../i18n/LanguageContext";

const TITLES = {
    "/": {
        es: "Pentomino — Reciclamos el efectivo donde se recibe",
        en: "Pentomino — We recycle cash where it comes in",
    },
    "/servicios": {
        es: "Servicios — Pentomino Cash",
        en: "Services — Pentomino Cash",
    },
    "/comercios": {
        es: "Comercios — Pentomino Cash",
        en: "Merchants — Pentomino Cash",
    },
    "/bancos": {
        es: "Bancos sponsor — Pentomino Cash",
        en: "Sponsor banks — Pentomino Cash",
    },
    "/personas": {
        es: "Personas — Pentomino Cash",
        en: "People — Pentomino Cash",
    },
    "/nosotros": {
        es: "Nosotros — Pentomino Cash",
        en: "About — Pentomino Cash",
    },
    "/contacto": {
        es: "Contacto — Pentomino Cash",
        en: "Contact — Pentomino Cash",
    },
};

const DESCRIPTIONS = {
    "/": {
        es: "Pentomino instala cajeros recicladores en comercios: hasta 90% menos costo de manejo de efectivo. Trust. Delivered.",
        en: "Pentomino installs cash-recycling ATMs in merchants: up to 90% lower cash-handling cost. Trust. Delivered.",
    },
    "/servicios": {
        es: "Las cinco líneas de Pentomino: CASH, NETWORK, TECH, PAYMENTS y PARTNERS.",
        en: "Pentomino's five service lines: CASH, NETWORK, TECH, PAYMENTS and PARTNERS.",
    },
    "/comercios": {
        es: "Menos recolecciones, menos manejo de efectivo y una participación por cada retiro. Calcula tu ahorro.",
        en: "Fewer pickups, less cash handling and a revenue share per withdrawal. Calculate your savings.",
    },
    "/bancos": {
        es: "Más red transaccional sin desplegar red propia: ingresos recurrentes, fondeo de bajo costo, expansión sin CAPEX.",
        en: "More transactional network without rolling out your own: recurring revenue, low-cost funding, zero-CAPEX expansion.",
    },
    "/personas": {
        es: "Retira efectivo, paga servicios, recarga tiempo aire o cobra remesas en los comercios donde ya haces tus compras.",
        en: "Withdraw cash, pay bills, top up airtime or pick up remittances at the stores where you already shop.",
    },
    "/nosotros": {
        es: "Pentomino Cash convierte efectivo disperso en infraestructura financiera. Trust. Delivered.",
        en: "Pentomino Cash turns scattered cash into financial infrastructure. Trust. Delivered.",
    },
    "/contacto": {
        es: "Agenda una sesión por WhatsApp o déjanos tus datos. Oficinas en Av. Coyoacán 1622, CDMX.",
        en: "Book a session on WhatsApp or leave your details. Offices at Av. Coyoacán 1622, Mexico City.",
    },
};

export const useDocumentTitle = (pathname) => {
    const { lang } = useLang();
    useEffect(() => {
        const t = TITLES[pathname]?.[lang] || TITLES["/"]?.[lang];
        const d = DESCRIPTIONS[pathname]?.[lang] || DESCRIPTIONS["/"]?.[lang];
        if (t) document.title = t;
        if (d) {
            let meta = document.querySelector('meta[name="description"]');
            if (!meta) {
                meta = document.createElement("meta");
                meta.setAttribute("name", "description");
                document.head.appendChild(meta);
            }
            meta.setAttribute("content", d);
        }
    }, [pathname, lang]);
};
